import controller from './by-last-items.controller'
import templateBase from './templates/by-last-items-base.view.html'
import templateAD from "./templates/by-last-items-adaptative.html";

let ByLastitemsComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {
    return templateBase;
    }*/
    if (__env.adaptative) {
        return templateAD;
    } else {
        return templateBase;
    }
}

export default ByLastitemsComponent



/** WEBPACK FOOTER **
 ** ./www/components/fast-purchase/by-last-items/by-last-items.component.js
 **/